import { Order, ShipmentMinimal } from '../../../types/api'
import { PickAndPackStatus } from '../types'
import { PackableItem } from './types'

export function packableItemListFromOrder(order: Order): PackableItem[] {
  // Maintain the initial picked status so we can keep track of the Not found status.
  // Also maintain previous status for (single) undo support
  return order.orderItems.map(item => {
    return {
      ...item,
      packedQuantity: item.pickedStatus === 'PACKED' ? 1 : 0,
      previousPickedStatus: item.pickedStatus as PickAndPackStatus
    }
  })
}

export function resetPackableItemListFromOrder(order: Order): PackableItem[] {
  return order.orderItems.map(item => {
    return {
      ...item,
      packedQuantity: 0,
      pickedStatus: null
      // The OrderItem could have a pickedStatus of PICKED, and this would seem dangerous.
      // But we don't allow submitting this pickedStatus (they have to change it to PACKED or EXCLUDED_FROM_PACKING).
    }
  })
}

export function selectedBoxesListFromShipments(shipments: ShipmentMinimal[]) {
  return shipments.map(shipment => {
    return {
      id: shipment.shippingBoxId === -1 ? 'custom' : shipment.shippingBoxId,
      shipmentId: shipment.id,
      orderItemIds: shipment.orderItemIds,
      key: shipment.id
    }
  })
}

export function isItemPacked(item: PackableItem): boolean {
  return [PickAndPackStatus.EXCLUDED_FROM_PACKING, PickAndPackStatus.PACKED].includes(
    item.pickedStatus as PickAndPackStatus
  )
}

// Release focus back to the body (to allow for scanning)
export function blurActiveInput() {
  ;(document.activeElement as HTMLElement)?.blur()
}
